import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-designation-for-salt-form',
  templateUrl: './designation-for-salt-form.component.html',
  styleUrls: ['./designation-for-salt-form.component.scss']
})
export class DesignationForSaltFormComponent implements OnInit {
  @ViewChild('designationInput') designationInput!: ElementRef;
  designation!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.designation = this.currentFormValue;
  }
  
  public clearDesignationInputField() {
    this.designation = '';
    this.currentForm.patchValue({'designationForSaltForm': ''});
  }

  public updateDesignation(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;

      if(target && target.nodeValue === "cancel") {
        this.designation = '';
      }
    
    }

    this.currentForm.patchValue({'designationForSaltForm': this.designation});
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  get currentFormValue(): string {
    return this.currentForm.get('designationForSaltForm')?.value;
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }
}
